import Vue from 'vue'

export default {
  setLoading (state, loading) {
    state.loading = loading
  },
  setData (state, data) {
    state.meta = data.meta
    state.data = data.data
  },
  setDatum (state, data, key = 'id') {
    const index = state.data.findIndex(datum => datum[key] === data.data[key])

    if (0 > index) {
      // Not found
      state.data.unshift(data.data)

      return
    }

    Vue.set(state.data, index, data.data)
  },
  deleteDatum (state, id, key = 'id') {
    const index = state.data.findIndex(datum => datum[key] === id)

    if (0 > index) {
      // Not found
      return
    }

    state.data.splice(index, 1)
  },
}
